import { inject, Injectable } from '@angular/core';
import { CanActivateChild, GuardResult, MaybeAsync } from '@angular/router';
import { ClientProcessingService } from '@services/client-processing.service';

@Injectable({
  providedIn: 'root',
})
export class EnsureClientIsNotProcessing implements CanActivateChild {
  private clientProcessingService = inject(ClientProcessingService);

  canActivateChild(): MaybeAsync<GuardResult> {
    // Aucun appel réseau : l'état de synchro vient des réponses 423 (interceptor).
    // On bloque simplement toute navigation tant que le client est verrouillé,
    // l'utilisateur reste sur place. Le premier chargement passe (signal à false)
    // puis la première réponse 423 déclenche l'overlay.
    if (!this.clientProcessingService.isProcessing()) {
      return true;
    }

    this.clientProcessingService.notifyLocked();
    return false;
  }
}
